import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  UPDATE_LOCATION,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_ERROR,
} from './../../../actionType'

function* updateLocation({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/${payload.id}`,
      method: 'GET',
      headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: UPDATE_LOCATION_SUCCESS, payload: response })
    } else {
      yield put({ type: UPDATE_LOCATION_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: UPDATE_LOCATION_ERROR, payload: error })
  }
}

export function* watchUpdateLocation() {
  yield takeEvery(UPDATE_LOCATION, updateLocation)
}

function* updateLocationSaga() {
  yield all([fork(watchUpdateLocation)])
}

export default updateLocationSaga
